// Classic › player page (#1119). Shared words (Season, Roster, Game/Match,
// the competition picker, empty states) come from useLabels(); sport-pack
// stat names come from the pack.
import { plural, select } from '../../../plural'

const en = {
  notFoundTitle: 'Player Not Found',
  notFoundBody: 'This player does not exist',
  backToPlayers: 'Back to Players',
  silhouetteAlt: 'Player silhouette',
  active: 'Active',
  inactive: 'Inactive',
  bio: {
    height: 'Height',
    weight: 'Weight',
    position: 'Position',
    number: 'Number',
  },
  team: 'Team',
  statsHeading: 'Statistics',
  seasonSelectLabel: 'Select Season',
  seasonSelectPlaceholder: 'Choose a season...',
  seasonFilterLabel: 'Filter by Season (Optional)',
  allSeasons: 'All Seasons',
  /** Under a per-game tile: "212 total points" (the stat name is the pack's, lower-cased). */
  tileTotal: (value: string, statLabel: string) => `${value} total ${statLabel.toLowerCase()}`,
  photos: {
    heading: 'Photos',
    viewAll: 'View all photos →',
    open: 'Open photo',
  },
  gameLog: {
    loading: 'Loading game log…',
    /** "Fall 2026 · 8 games" (the scope is a season name, so it stays out of plural()). */
    summary: (scope: string, count: number, sport: string) =>
      `${scope} · ${select(sport, {
        soccer: plural(count, { one: '# match', other: '# matches' }),
        other: plural(count, { one: '# game', other: '# games' }),
      })}`,
    date: 'Date',
    opponent: 'Opp',
    result: 'Result',
    didNotPlay: 'Did not play',
    /** The group heading for games outside any season or competition. */
    otherGroup: 'Other',
    /** Before the opponent: a home game. Away games show "@". */
    versus: 'vs',
  },
}

export default en
